module.exports = __webpack_public_path__ + "img/hr-tree-07-b-trunk.5cdbd756.png";